import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { routerReducer } from 'react-router-redux'

import auth from './auth'
import checklist from './checklist'
import comment from './comment'
import defect from './defect'
import defectArea from './defect-area'
import file from './file'
import loading from './loading'
import mainArea from './main-area'
import project from './project'
import summary from './summary'
import user from './user'

const rootReducer = combineReducers({
  form: formReducer,
  routing: routerReducer,
  auth,
  checklist,
  comment,
  defect,
  defectArea,
  file,
  loading,
  mainArea,
  project,
  summary,
  user,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js